import {
  Swiper, Lazy, Pagination, Navigation,
} from 'swiper';
import $ from 'jquery';

const swiperContainerClass = '.content-box__slider';
const swipers = [];

function afterSmoothScroll(event, hash) {
  const $expand = $(hash).find('.c-expander__button-label:visible');

  if ($expand.length && !$expand.hasClass('expanded')) {
    $expand.trigger('click');
  }
}

$(document).ready(() => {
  $(document).on('afterSmoothScroll', afterSmoothScroll);
});

function initSlider($slider) {
  // eslint-disable-next-line no-new
  const swiper = new Swiper($slider[0], {
    lazy: true,
    loop: true,
    keyboard: {
      enabled: true,
    },
    modules: [Lazy, Pagination, Navigation],
    navigation: {
      nextEl: $slider.find('.content-box__btn--next')[0],
      prevEl: $slider.find('.content-box__btn--prev')[0],
    },
    pagination: {
      clickable: true,
      el: '.content-box__pagination',
    },
    on: {
      beforeInit(swiper) {
        const numberOfSlides = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate )').length;
        if (numberOfSlides <= 1) {
          this.params.loop = false;
        }
      },
    },
  });

  // Added keyboard navigation to swiper bullets
  $slider.find('.swiper-pagination-bullet').each(function (index) {
    const bullet = $(this);
    bullet.attr('id', (index + 1));
  });

  $slider.find('.swiper-pagination').each(() => {
    $slider.find('.swiper-pagination-bullet').attr('tabindex', 0);
    $slider.find('.swiper-pagination-bullet').on('keydown', function (event) {
      if (event.keyCode == '13') {
        const slideID = $(this).attr('id');
        swiper.slideTo(slideID - 1);
      }
    });
  });

  swipers.push(swiper);
}

function init() {
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    if ($slider && $slider.find('.swiper-slide').length > 1) {
      initSlider($slider);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=content-box', ($block) => {
      const $slider = $block.find(swiperContainerClass);
      if ($slider && $slider.length > 1) {
        initSlider($slider[0]);
      }
    });
  } else {
    init();
  }
});
